"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_RFC = exports.EMAIL_RFC_LOCALPART = exports.EMAIL_DOMAIN = exports.EMAIL_EXPERIUM = void 0;
var EMAIL_EXPERIUM = /^([a-zA-Z0-9\-_\.]+)@([a-zA-Z0-9\-\.]+)$/;
exports.EMAIL_EXPERIUM = EMAIL_EXPERIUM;
var EMAIL_DOMAIN = /^.*@([a-zA-Z0-9\.\-]+)$/;
exports.EMAIL_DOMAIN = EMAIL_DOMAIN;
var EMAIL_RFC_LOCALPART = /^([a-zA-Z0-9\-_\.]{1,64})@([a-zA-Z0-9\-\.]+)$/;
exports.EMAIL_RFC_LOCALPART = EMAIL_RFC_LOCALPART;
var EMAIL_RFC = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
exports.EMAIL_RFC = EMAIL_RFC;